// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface DiscussionsAppliedFilter
 */
export interface DiscussionsAppliedFilter {
    /**
     * 
     * @type {string}
     * @memberof DiscussionsAppliedFilter
     */
    filterOn: DiscussionsAppliedFilterFilterOnEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscussionsAppliedFilter
     */
    filterValues: Array<string>;
}

export function DiscussionsAppliedFilterFromJSON(json: any): DiscussionsAppliedFilter {
    return {
        'filterOn': json['filter_on'],
        'filterValues': json['filter_values'],
    };
}

export function DiscussionsAppliedFilterToJSON(value?: DiscussionsAppliedFilter): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'filter_on': value.filterOn,
        'filter_values': value.filterValues,
    };
}

/**
* @export
* @enum {string}
*/
export enum DiscussionsAppliedFilterFilterOnEnum {
    Category = 'Category',
    SubCategory = 'SubCategory',
    Tag = 'Tag'
}


